import React from 'react';
import { Container, Typography, Paper, Box, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { text as textColors, bg } from '../../utils/darkModeAdapter';
import Layout from '../../components/Layout';

function Privacy() {
  const theme = useTheme();
  return (
    <Layout>
      <Container maxWidth="md" sx={{ pt: 8, pb: 3 }}>
        <Paper elevation={1} sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 3, color: textColors(theme).primary, fontWeight: 'bold', textAlign: 'center' }}>
            プライバシーポリシー
          </Typography>
          
          <Typography variant="h6" sx={{ mb: 2, color: textColors(theme).secondary, textAlign: 'center' }}>
            AI人事 プライバシーポリシー 25.06.26
          </Typography>

          <Divider sx={{ mb: 3 }} />

          <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 3 }}>
            当社は、中小企業向け人事支援SaaS「AI人事」（以下「本サービス」）の提供にあたり、ユーザー企業およびその採用候補者等の個人情報を取り扱います。当社は、個人情報の保護に関する法律（個人情報保護法）その他の関連法令およびガイドラインを遵守し、以下のとおりプライバシーポリシー（以下「本ポリシー」）を定め、個人情報の適切な取扱いに努めます。本ポリシーは、本サービスに関連して当社が取得するすべての個人情報の取扱いに適用されます。
          </Typography>
          
          <Box sx={{ '& > *': { mb: 3 } }}>

            <Box>
              <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: textColors(theme).primary, mb: 1 }}>
                1．事業者の名称等
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                当社名：株式会社綜合企画
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                所在地：〒107-0052  東京都港区赤坂５丁目２−３３ IsaI AkasakA 6F
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                代表者：代表取締役  岩崎尚美
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: textColors(theme).primary, mb: 1 }}>
                2．取得する個人情報の項目
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                当社は、本サービスの提供に必要な範囲で以下の個人情報を取得します。なお、ユーザー企業が当社サービス上に入力する候補者等の情報については、ユーザー企業がその取得元であることを認識した上で提供いただくものとします。
              </Typography>
              <Box sx={{ pl: 2 }}>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                  <strong>• ユーザー企業に関する情報：</strong>会社名、所在地、業種、担当者氏名、部署名、役職、連絡先（電話番号、メールアドレス）等の企業情報および担当者個人に関する情報。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                  <strong>• 求人情報に関する情報：</strong>求人票に含まれる募集職種、業務内容、勤務地、労働条件（雇用形態、給与、勤務時間等）ならびに雇用対策法や職業安定法等の法令に基づき表示・収集が必要な事項（例：障がい者雇用促進に関する取り組み状況等）。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                  <strong>• 採用候補者に関する情報：</strong>ユーザー企業が採用選考のため本サービス上で管理する応募者・候補者の氏名、年齢、性別、連絡先（住所・電話番号・メールアドレス等）、履歴書・職務経歴書記載事項（学歴、職歴、資格等）、面接評価や選考プロセスにおけるメモ等の人事評価情報。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                  <strong>• サービス利用情報：</strong>本サービスの利用履歴・ログ（ログイン日時、操作履歴等）、本サービス内でユーザーが入力または取得したデータ（チャット機能での対話内容や生成された求人票・Q&Aコンテンツ等）、お問い合わせ内容、お問い合わせ時の情報（担当者氏名、メールアドレス等）、およびクッキー情報、IPアドレス等のアクセス情報。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                  <strong>• 決済・契約情報：</strong>本サービス利用料金の請求・支払いに関する情報（請求先氏名・住所、銀行口座情報またはクレジットカード情報※決済代行会社を通じて取得）等。
                </Typography>
              </Box>
            </Box>

            <Box>
              <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: textColors(theme).primary, mb: 1 }}>
                3．利用目的
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                当社は、取得した個人情報を以下の目的の達成に必要な範囲内で利用いたします。目的外の利用は法令により許容される場合または本人の同意がある場合を除き行いません。
              </Typography>
              <Box sx={{ pl: 2 }}>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                  <strong>• 本サービスの提供・運営のため：</strong>ユーザー企業に対し本サービスの各種機能（採用計画・求人作成、候補者情報管理、マッチング分析、チャットボット等）を提供し、本人確認・認証、ユーザーアカウント管理、利用料金の請求・決済処理を行うため。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                  <strong>• 採用支援業務遂行のため：</strong>ユーザー企業から委託を受けて候補者情報を取り扱う場合において、当該採用選考支援業務を適切に遂行するため。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                  <strong>• サービスの維持改善のため：</strong>本サービスおよび関連サービスの機能改善、新機能の研究開発や品質向上のため、アンケートの実施、利用状況の分析、統計データの作成等に個人情報を含む利用者情報を活用するため。取得した情報は個人を特定できない形に加工した統計データを作成し、サービスの改善やマーケティング等に利用します。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                  <strong>• お問い合わせ・サポート対応のため：</strong>ユーザーからのお問い合わせ、相談、苦情に対応し、必要な連絡や検証を行うため。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                  <strong>• 通知・ご案内のため：</strong>サービスに関する重要なお知らせや契約更新・メンテナンス情報等を連絡するため。また、ユーザー企業に対し当社または提携先の商品・サービスに関するセミナー情報、キャンペーン情報、メールマガジン配信等のご案内をお送りするため。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                  <strong>• 不正・違反行為の防止のため：</strong>本サービスの適切な運用を確保するために、利用規約に違反する行為や不正アクセス等の調査・検出・予防措置を講じるため。
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                  <strong>• 法令遵守およびその他上記各目的に付随する目的のため：</strong>法令に基づくご本人様の権利行使への対応や、その他本人の同意を得た範囲で利用するため。
                </Typography>
              </Box>
            </Box>

            <Box>
              <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: textColors(theme).primary, mb: 1 }}>
                4．第三者提供について
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                当社は、取得した個人情報について、以下の場合を除き、ご本人の同意なく第三者に提供いたしません。
              </Typography>
              <Box sx={{ pl: 2 }}>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  • 法令に基づく場合、または裁判所・行政機関から適法に開示を要求された場合
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  • 人の生命、身体または財産の保護のために必要で、本人の同意を得ることが困難な場合
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  • 公衆衛生の向上または児童の健全育成の推進のため特に必要で、本人の同意を得ることが困難な場合
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  • 国の機関もしくは地方公共団体等が法令の定める事務を遂行するうえで協力する必要がある場合
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  • その他個人情報保護法で第三者提供が認められる場合
                </Typography>
              </Box>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary }}>
                なお、当社は本サービスの運営にあたり、必要な範囲で個人情報の取扱いを業務委託先（クラウドサーバ事業者、データ分析事業者、外部AIサービス提供者等）に委託することがあります。この場合、当社は委託先との間で適切な契約を締結し、委託先が安全管理措置を講じるよう監督いたします。業務委託は第三者提供には該当せず、当社の責任において行われます。加えて、ユーザーが本サービスのAI連携機能を利用する際、入力データが海外にある外部AIサービス（例：OpenAI社（米国））に送信される場合があります。この場合でも当社は提供元において当該データが機械学習の目的に利用されない契約上の措置を講じています。
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: textColors(theme).primary, mb: 1 }}>
                5．個人情報の管理方法
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary }}>
                当社は、取り扱う個人情報の漏えい、滅失、毀損を防止するため、必要かつ適切な安全管理措置を講じます。具体的には、個人情報へアクセスできる担当者の限定、アクセス権限の管理、通信の暗号化、システムの防御措置（ファイアウォール等）、従業員への教育など、技術面および組織面から合理的な安全対策を実施します。また、当社はJIS Q 15001等の規格や個人情報保護委員会のガイドラインに準拠した内部規程を整備し、個人情報保護マネジメントシステムの継続的な改善に努めます。
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: textColors(theme).primary, mb: 1 }}>
                6．個人情報の開示等の請求
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary }}>
                当社は、ご本人から自己の個人情報に関する利用目的の通知、開示、内容の訂正・追加・削除、利用停止・消去、第三者提供の停止等（「開示等」といいます）の請求があった場合、速やかに対応します。開示等の求めの手続きについては、当社ウェブサイトの問い合わせ窓口よりご連絡ください。本人確認の上で法令に従い対応いたします。なお、ユーザー企業が当社サービス上に保存した採用候補者の個人情報については、当社はユーザー企業からの指示に基づき対応いたします。候補者本人から直接当社に開示等の請求があった場合には、当該請求内容をユーザー企業に通知し、必要な対応について協力いたします。
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: textColors(theme).primary, mb: 1 }}>
                7．プライバシーポリシーの変更
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary }}>
                当社は、社会情勢の変化や法令の改正等に伴い、本ポリシーの内容を適宜見直し、改善いたします。ポリシーを変更する場合は、変更後の内容を当社ウェブサイト上に掲示するか、ユーザーへの電子メール等適切な方法で通知いたします。法令上ユーザーの同意が必要となる重要な変更を行う場合には、所定の方法でユーザーの同意を取得します。本ポリシーの変更は、公表した実施日より効力を生じます。
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: textColors(theme).primary, mb: 1 }}>
                8．お問い合わせ窓口
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 2 }}>
                本ポリシーや当社における個人情報の取扱いに関するお問い合わせ、苦情、相談等は、以下の窓口までご連絡ください。
              </Typography>
              <Box sx={{ pl: 2, bgcolor: bg(theme).tinted, p: 2, borderRadius: 1 }}>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  〒107-0052  東京都港区赤坂５丁目２−３３ IsaI AkasakA 6F
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  株式会社綜合企画
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary, mb: 1 }}>
                  E-mail: otoiawase@sogoplan.co.jp
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: textColors(theme).secondary }}>
                  Tel: 03-5564-2131（平日10:00〜18:00）
                </Typography>
              </Box>
            </Box>

            <Typography variant="body1" sx={{ textAlign: 'center', color: textColors(theme).secondary, mt: 3, fontWeight: 'bold' }}>
              以上
            </Typography>

          </Box>
        </Paper>
      </Container>
    </Layout>
  );
}

export default Privacy; 